

















import {
  defineComponent,
  ref,
  computed,
  useContext,
  onMounted,
  PropType,
} from '@nuxtjs/composition-api'
import { v4 as guid } from 'uuid'
import { debounce } from 'throttle-debounce'
import InputSelect from '@/components/Inputs/InputSelect.vue'
import { FormInputType } from '@/contracts/FormInputType'
import { AutoOption } from '@/components/FormInput/BlockNearestOffice.typing'

export default defineComponent({
  name: 'BlockSelectAuto',
  components: {
    InputSelect,
  },
  props: {
    value: {
      type: Object as PropType<AutoOption>,
      default: null,
    },
    label: {
      type: String as PropType<string>,
      default: '',
    },
    error: {
      type: [String, Boolean] as PropType<string | boolean>,
      default: '',
    },
  },
  setup(_, ctx) {
    const debouncer = debounce(700, false, (search: string) =>
      getModels(search)
    )
    const isCompareAuto = (option: AutoOption, data: AutoOption | null) =>
      option?.value?.value === data?.value?.value

    const { $api } = useContext()
    const models = ref([])
    onMounted(() => {
      getModels('a')
    })
    const selectId = guid()
    const isChoiceCompleted = ref<boolean>(false)

    const selectOptions = computed(() => ({
      id: selectId,
      label: 'Марка и модель автомобиля',
      type: FormInputType.Text,
      placeholder: 'Например, Ford Focus или ВАЗ 2109',
      noResultText: '',
      disabled: false,
      required: true,
      error: false,
      rules: [],
      isDarkTheme: false,
      selectOptions: models.value.map((it: any) => ({
        name: it.label,
        value: it,
      })),
      useBorder: true,
    }))

    const onChange = (option: any) => {
      isChoiceCompleted.value = true
      ctx.emit('input-change', option)
    }
    const getModels = (search: string) => {
      if (!search.length) return
      isChoiceCompleted.value = false
      $api.requests.getVehicleModels(search).then((response) => {
        if (response && !isChoiceCompleted.value) {
          models.value = response.data.data.filter(
            (auto: any) => !!auto.carrier_type.trim()
          )
        }
      })
    }

    return {
      selectOptions,
      models,
      onChange,
      getModels,
      debouncer,
      isCompareAuto,
    }
  },
})
